// src/routes/_org/org/portal/compliance.tsx
import { createFileRoute } from '@tanstack/react-router';

import { CompliancePage } from '@/features/org-analytics/pages/CompliancePage';

export const Route = createFileRoute('/_org/org/portal/compliance')({
  component: CompliancePage,
});
